const SectionHeader = function ($sce, $scope, questionnaireInteractor) {
  const $ctrl = this;

  $ctrl.$onChanges = function () {
    if ($ctrl.section) {
      $ctrl.newTitle = angular.copy($ctrl.section.title);
      $ctrl.newDescription = angular.copy($ctrl.section.description);
      $ctrl.wysiwygId = ($ctrl.section.title + 'wysiwig').replace(/ /g, '');
    }
  };

  $ctrl.changeTitle = function (newTitle) {
    questionnaireInteractor.updateSectionTitle(
      $ctrl.questionnaireId,
      $ctrl.section.title,
      newTitle,
      function (updatedTitle) {
        $ctrl.reloadSections();
      },
      function () {
        window.alert('Oops! We failed to change the title of the section ' + $ctrl.section.title);
      }
    )
  };

  $ctrl.saveDescription = function (content) {
    return new Promise(resolve => {
      questionnaireInteractor.updateSectionDescription(
        $ctrl.questionnaireId,
        $ctrl.section.title,
        content,
        (updatedDescription) => {
          $scope.$digest();
          resolve();
        },
        () => {
          throw('Oops! We failed to change the title of the section ' + $ctrl.section.title);
        }
      )
    });
  };

  $ctrl.tagSection = function (newTagName) {
    questionnaireInteractor.tagSection(
      $ctrl.questionnaireId,
      $ctrl.section.title,
      newTagName,
      function (tag) {
        if ($ctrl.section.tags.indexOf(tag) == -1) {
          $ctrl.section.tags.push(tag);
        }
        $ctrl.newTag = '';
        $ctrl.addingTag = false;
        $scope.$digest();
      },
      function () {
        window.alert('Oops! We failed to apply the tag ' + newTagName);
      });
  };

  $ctrl.untagSection = function (tagName) {
    questionnaireInteractor.untagSection(
      $ctrl.questionnaireId,
      $ctrl.section.title,
      tagName,
      function () {
        $ctrl.section.tags.splice($ctrl.section.tags.indexOf(tagName), 1);
        $scope.$digest();
      },
      function () {
        window.alert('Oops! We failed to remove the tag ' + tagName);
      });
  };

  $ctrl.deleteThisSection = function () {
    $ctrl.deleteSection({title: $ctrl.section.title});
  };

  $ctrl.cancelEditTitle = function () {
    $ctrl.editingTitle = false;
    $ctrl.newTitle = angular.copy($ctrl.section.title);
  };

  $ctrl.getDescriptionHtml = function () {
    return $sce.trustAsHtml($ctrl.section.description || 'No description yet.');
  };
};

export default {
  name: 'sectionHeader',
  obj: {
    controller: SectionHeader,
    templateUrl: 'components/section_header.html',
    bindings: {
      moveUp: '&',
      moveDown: '&',
      reloadSections: '&',
      deleteSection: '&',
      questionnaireId: '<',
      section: '<',
      enableMoveUp: '<',
      enableMoveDown: '<'
    }
  },
  deps: []
}